/**
 * Returns the first page a staff member goes to after login.
 * Staff always lands on StaffDashboard — their own portal.
 * From there they can navigate to their permitted sections.
 */
export function getStaffFirstPage(permissions = {}) {
  return '/doctor/staff-dashboard';
}
